import { AlertCircle, ShieldQuestion } from "lucide-react";

// Reused wherever a screen the prompt asks for has genuinely NO backend endpoint reachable by
// this role on the current backend (never a permission the role merely lacks — those are
// handled by simply not rendering the action at all, per the "absent not disabled" rule
// elsewhere in this build). This is for the smaller set of cases where NOTHING would persist no
// matter who's asking, so an honest static disclaimer replaces a form that would silently do
// nothing — per every UX-FD prompt's own "flag it, don't fabricate" instruction.
export function NotAvailablePanel({ title, reason, testId }) {
  return (
    <div data-testid={testId} className="rounded-[14px] p-5 flex items-start gap-3" style={{ background: "#FBF6EC", border: "1px solid #EEDFB8" }}>
      <AlertCircle size={18} className="mt-0.5 shrink-0" style={{ color: "#9A6B00" }} />
      <div>
        <p className="flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#7A5300" }}><ShieldQuestion size={14} /> {title}</p>
        <p className="text-xs mt-1" style={{ color: "#7A5300" }}>{reason}</p>
      </div>
    </div>
  );
}
